var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminprowhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62296 1.96267C5.32296 3.16267 3.02296 5.46267 1.82296 7.86267C-4.77704 20.7627 7.62296 33.6627 21.723 28.7627C24.123 27.9627 25.623 27.8627 27.423 28.7627L29.823 29.8627V20.7627C29.823 9.66267 27.823 4.96267 21.823 1.86267C16.923 -0.637327 12.423 -0.637327 7.62296 1.96267ZM20.923 8.76267C24.823 12.7627 24.823 16.9627 20.923 20.9627C18.923 22.9627 17.023 23.8627 14.823 23.8627C12.623 23.8627 10.723 22.9627 8.72296 20.9627C4.82296 16.9627 4.82296 12.7627 8.72296 8.76267C10.723 6.76267 12.623 5.86267 14.823 5.86267C17.023 5.86267 18.923 6.76267 20.923 8.76267Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.823 12.3627C10.323 14.1627 10.823 16.8627 13.123 18.2627C16.523 20.4627 20.423 15.5627 17.823 12.3627C16.223 10.4627 13.423 10.4627 11.823 12.3627Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminprowhite);
export default __webpack_public_path__ + "static/media/adminprowhite.470651e7acb051e35791e2b80471dfc8.svg";
export { ForwardRef as ReactComponent };